<template>
  <vx-card title="Approval Force End Session">
    <vs-tabs>
      <vs-tab label="Open">
        <div class="tab-text">
          <DataTable status="0"/>
        </div>
      </vs-tab>
      <vs-tab label="Approved">
        <div class="tab-text">
          <DataTable status="1"/>
        </div>
      </vs-tab>
      <vs-tab label="Rejected">
        <div class="tab-text">
          <DataTable status="2"/>
        </div>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import DataTable from './DataTable.vue'
export default {
  components: {
    DataTable,
  }
}
</script>